




































































import { Vue, Component, Mixins } from 'vue-property-decorator'

// @ts-ignore
import MyDvBox from '$ui/dv/packages/my-dv-box'

import MyBox from '@/components/box.vue'

import MyCommon from '@/mixins/common'

@Component({
  components: {
    MyDvBox,
    MyBox,
  },
})
export default class extends Mixins(MyCommon) {}
